import { Card, CardContent, Box, Typography, IconButton, FormControl, InputLabel, Select, MenuItem, Button, TextField, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const ConversationBlock = ({ block, agents, index, updateBlock, removeBlock }) => {

    const addAgent = () => {
        console.log(`Adding new agent to block ${index}: ${block.agents}`);

        const updatedAgents = [...(block.agents || []), {
            agent_id: ''
        }];
        updateBlock(index, { ...block, agents: updatedAgents });
    };

    const updateAgent = (agentIndex, updatedAgent) => {
        console.log(`Updating agent ${agentIndex} in block ${index}:`, updatedAgent);
        const updatedAgents = [...block.agents];
        updatedAgents[agentIndex] = {
            ...updatedAgents[agentIndex],
            ...updatedAgent,
        };
        updateBlock(index, { ...block, agents: updatedAgents });
    };

    const handleEndConditionChange = (event) => {
        const newEndCondition = event.target.value;
        console.log(`Updating end condition for block ${index}: ${newEndCondition}`);
        updateBlock(index, { ...block, end_condition: newEndCondition });
    };

    const removeAgent = (agentIndex) => {
        console.log(`Removing agent ${agentIndex} from block ${index}`);
        const updatedAgents = block.agents.filter((_, i) => i !== agentIndex);
        updateBlock(index, { ...block, agents: updatedAgents });
    };

    return (
        <Card sx={{ mb: 2, p: 2 }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6">Conversation Block</Typography>
                    <IconButton onClick={() => removeBlock(index)}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
                
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>End Condition</InputLabel>
                    <Select
                        value={block.end_condition || 'None'}
                        onChange={handleEndConditionChange}
                    >
                        <MenuItem value="None">No Condition</MenuItem>
                        <MenuItem value="duration">Duration</MenuItem>
                    </Select>
                    {block.end_condition === 'duration' && (
                        <TextField
                            type="number"
                            size="small"
                            label="Timeout (minutes)"
                            value={block.timeoutDuration || ''}
                            onChange={(e) => updateBlock(index, { ...block, timeoutDuration: e.target.value })}
                            slotProps={{
                                htmlInput: {
                                    min: 0,
                                    max: 999,
                                    style: { width: 160, textAlign: 'center' }
                                }
                            }}
                            sx={{ mt: 2, width: 200 }}
                        />
                    )}
                </FormControl>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ mr: 2 }}>Randomize Agents:</Typography>
                    <FormControl>
                        <Select
                            value={block.randomize ? 'true' : 'false'}
                            onChange={(e) => updateBlock(index, { 
                                ...block, 
                                randomize: e.target.value === 'true'
                            })}
                            size="small"
                        >
                            <MenuItem value="true">Yes</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                
                {/* Block-level introduction and outroduction */}
                <Box sx={{ mb: 2 }}>
                    <TextField
                        fullWidth
                        label="Introduction Text"
                        multiline
                        rows={2}
                        value={block.introText || block.introduction_text || ''}
                        onChange={e => updateBlock(index, { ...block, introText: e.target.value })}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        fullWidth
                        label="Outroduction Text"
                        multiline
                        rows={2}
                        value={block.outroText || block.outroduction_text || ''}
                        onChange={e => updateBlock(index, { ...block, outroText: e.target.value })}
                    />
                </Box>
                
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                        Task Details
                    </Typography>
                    <TextField
                        fullWidth
                        label="Task Description"
                        multiline
                        rows={3}
                        value={block.task_description || ''}
                        onChange={e =>
                            updateBlock(index, {
                                ...block,
                                task_description: e.target.value
                            })
                        }
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        fullWidth
                        label="Expected Output"
                        multiline
                        rows={2}
                        value={block.task_expected_output || ''}
                        onChange={e =>
                            updateBlock(index, {
                                ...block,
                                task_expected_output: e.target.value
                            })
                        }
                        sx={{ mb: 2 }}
                    />
                </Box>
                
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Agents ({(block.agents || []).length} trials)
                </Typography>
                
                <Box sx={{ mb: 2, maxHeight: '300px', overflow: 'auto' }}>
                    {(block.agents || []).map((agent, agentIndex) => (
                        <Paper key={agentIndex} sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                <Typography variant="subtitle2">Agent {agentIndex + 1}</Typography>
                                <IconButton size="small" onClick={() => removeAgent(agentIndex)}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Box>
                            
                            <FormControl fullWidth sx={{ mb: 2 }}>
                                <InputLabel>Agent</InputLabel>
                                <Select
                                    value={agent.agent_id || ''}
                                    onChange={(e) => updateAgent(agentIndex, { 
                                        ...agent, 
                                        agent_id: e.target.value 
                                    })}
                                >
                                    {agents.map((a) => (
                                        <MenuItem key={a.id} value={a.id}>
                                            {a.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Paper>
                    ))}
                </Box>
                
                <Button 
                    variant="outlined" 
                    onClick={addAgent}
                    startIcon={<span>+</span>}
                >
                    Add Agent Trial
                </Button>

                
            </CardContent>
        </Card>
    );
};

export default ConversationBlock;
